import { render, staticRenderFns } from "./InsuranceCardError.vue?vue&type=template&id=6fb83cc0&scoped=true&"
import script from "./InsuranceCardError.vue?vue&type=script&lang=js&"
export * from "./InsuranceCardError.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCardError.vue?vue&type=style&index=0&id=6fb83cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb83cc0",
  null
  
)

export default component.exports